import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  cardWrapper: {
    margin: '24px 40px',
    padding: '20px'
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '10px 40px 24px'
  },
  paper: {
    maxHeight: '200px',
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      width: '5px'
    },

    '&::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#c3c3c3',
      width: '5px'
    }
  },
  title: {
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '38px'
  },
  formContainer: {
    margin: '40px',
  },
  buttonContainer: {
    display: 'flex',
    marginTop: '20px'
  },
  button: {
    maxWidth: 220,
    margin: '20px 0'
  },
  primaryButton: {
    color: 'white',
    marginRight: '20px'
  },
  userHeaderWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    margin: '20px 20px',
  },
  formButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px'
  },
  link: {
    color: '#3B86FF',
    textDecoration: 'none',
    cursor: 'pointer'
  },
  modalButton: {
    margin: 20,
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
  },
  marginY: {
    margin: '3px 0'
  },
  marginB: {
    marginBottom: '3px'
  },
  marginT: {
    marginTop: '3px'
  },
  createdOnKey: {
    fontSize: '12px',
    color: '#0000008a',
    marginBottom: '8px'
  },
  createdonValue: {
    fontSize: '14px',
    color: '#545455'
  },
  input: {
    '@media (min-width: 3000px)': {
      '& svg': {
        top: 'calc(50% - 25px)'
      }
    }
  },
  privacyPolicy: {
    color: '#026AE3',
    cursor: 'pointer',
    textDecoration: 'none'
  }
}))

export { useStyles }